import { createFileRoute, redirect } from '@tanstack/react-router'
import { commonSearchSchema } from '@/lib/utils'

export const Route = createFileRoute('/')({
  validateSearch: commonSearchSchema,
  loader: () => {
    throw redirect({ to: '/login', replace: true })
  },
})
